<div class="header">
  <h1>Aztalena</h1>
  <p>Description about the website</p>
</div>

@if (isLoading) {
  <div class="loading-container">
    <app-loading></app-loading>
  </div>
}

@if (!isLoading) {
  <div class="container">
    <h2>Your forums</h2>
    <div class="forum-list">
      @for (forum of yourForums; track forum) {
        <app-home-forum-item [forum]="forum"></app-home-forum-item>
      }
    </div>
    <h2>Explore other forums</h2>
    <div class="forum-list">
      @for (forum of exploreForums; track forum) {
        <app-home-forum-item [forum]="forum"></app-home-forum-item>
      }
    </div>
  </div>
}
